import type { TrigKey } from './keys';

export const tr: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Matematik · Trigonometri',
  'panel.experiment': 'Deney',
  'panel.params': 'Parametreler',
  'panel.scene': 'Bir deney seç',
  'experiment.right-triangle.label': 'Dik üçgen',
  'experiment.unit-circle.label': 'Birim çember',
  'experiment.wave-studio.label': 'Dalga stüdyosu',
  'experiment.identity-playground.label': 'Özdeşlikler',
  'experiment.triangle-solver.label': 'Üçgen çözücü',
  'experiment.circular-polar.label': 'Dairesel & kutupsal',
  'hint.line1': 'Noktaları sürükle, kaydırıcıları kullan.',
  'hint.line2': 'Eğitim içerik geometride yaşar, metinde değil.',
  'rt.angle.a': 'Açı A',
  'rt.angle.b': 'Açı B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radyan',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° hizala',
  'uc.units': 'Birim',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC göster',
  'uc.snap.common': 'Ortak açılara hizala',
  'uc.angle.value': '∠',
  'uc.units.deg': 'derece',
  'uc.units.rad': 'rad',
  'uc.units.both': 'derece+rad',
  'ws.fn': 'Fonksiyon',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Genlik',
  'ws.frequency': 'B — Frekans',
  'ws.phase': 'C — Faz kayması',
  'ws.shift': 'D — Dikey kayma',
  'ws.rform.toggle': 'R-form türevi',
  'ws.rform.a': 'a (sin kat.)',
  'ws.rform.b': 'b (cos kat.)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Sıfırla',
  'ws.base': 'Temel eğriyi göster',
  'ip.id.pythagorean': 'Pisagor',
  'ip.id.reciprocal': 'Ters',
  'ip.id.quotient': 'Bölüm',
  'ip.id.sum': 'Toplam',
  'ip.id.difference': 'Fark',
  'ip.id.double': 'İki kat açı',
  'ip.id.half': 'Yarım açı',
  'ip.play': 'Oynat',
  'ip.pause': 'Duraklat',
  'ip.step': 'Adım',
  'ip.reset': 'Sıfırla',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2’de — bu ispat daha kapsamlı bir kurulum ister.',
  'ts.area': 'Alan',
  'ts.sineRule': 'Sinüs kuralı',
  'ts.cosineRule': 'Kosinüs kuralı',
  'ts.ambiguous.toggle': 'Belirsizken hayalet üçgen',
  'ts.reset': 'Eşkenara sıfırla',
  'ts.snap.integers': 'Tam sayılara hizala',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Kenarlar',
  'ts.section.angles': 'Açılar',
  'ts.section.sineRule': 'Sinüs kuralı',
  'ts.section.cosineRule': 'Kosinüs kuralı',
  'ts.section.area': 'Alan',
  'cp.omega': 'Açısal hız',
  'cp.plot.y': 'y çiz (sin)',
  'cp.plot.x': 'x çiz (cos)',
  'cp.polar.label': 'Kutupsal şekil',
  'cp.polar.circle': 'Çember (r = 1)',
  'cp.polar.rose': 'Gül (r = sin 3θ)',
  'cp.polar.cardioid': 'Kardioid (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Küçük açı yaklaşımı (sin x ≈ x)',
  'cp.play': 'Oynat',
  'cp.pause': 'Duraklat',
  'cp.reset': 'Sıfırla',
  'cp.step': 'Adım π/12',
};
